(function() {
  'use strict';

  const ENGRAVING_VARIANT_ID = 48583177273567;
  let engravingProcessed = false;

  // 🚫 Add product IDs here to disable auto-engraving for those products
  const EXCLUDED_PRODUCT_IDS = [
    8856641011935, 9092536565983, 9281548615903, 9281549533407, 9369745195231
  ];
    
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupEngraving);
    } else {
      setupEngraving();
    }
  }
  
  function setupEngraving() {
    interceptXHR();
    interceptFetch();
  }
  
  function interceptXHR() {
    const OriginalXHR = window.XMLHttpRequest;
    const originalOpen = OriginalXHR.prototype.open;
    const originalSend = OriginalXHR.prototype.send;
    
    OriginalXHR.prototype.open = function(method, url, ...rest) {
      this._url = url;
      this._method = method;
      return originalOpen.apply(this, [method, url, ...rest]);
    };
    
    OriginalXHR.prototype.send = function(body) {
      
      if (this._url && this._url.includes('/cart/add') && body) {
        
        try {
          let data = null;
          
          if (typeof body === 'string') {
            try {
              data = JSON.parse(body);
            } catch (e) {
            }
          }
          
          if (data && data.properties) {
            
            const engraveName = data.properties['Custom Engraving'] || data.properties['Engrave Name'] || data.properties['Engraving Name'];
            
            if (engraveName && engraveName.trim() && !engravingProcessed) {
              engravingProcessed = true;
              
              this.addEventListener('load', async function() {
                if (this.status === 200) {
                  try {
                    const mainProductData = JSON.parse(this.responseText);

                    // Skip engraving if product is in the excluded list
                    if (EXCLUDED_PRODUCT_IDS.length > 0 && EXCLUDED_PRODUCT_IDS.includes(mainProductData.product_id)) {
                      return;
                    }
                  
                    const engraveResponse = await fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        id: ENGRAVING_VARIANT_ID,
                        quantity: data.quantity || 1,
                        properties: {
                          '_for_product': mainProductData.product_title || 'Product',
                          '_engraved_name': engraveName.trim(),
                          '_main_product_engraving': 'true'
                        }
                      })
                    });
                    
                    if (engraveResponse.ok) {
                      const engraveData = await engraveResponse.json();
                      document.dispatchEvent(new CustomEvent('cart:updated'));
                    } else {
                      const errorData = await engraveResponse.json();
                      console.error('Failed to add engraving:', errorData);
                    }
                  } catch (error) {
                    console.error('Error:', error);
                  } finally {
                    setTimeout(() => { engravingProcessed = false; }, 2000);
                  }
                }
              });
            } else {
            }
          } else {
          }
        } catch (e) {
        }
      }
      
      return originalSend.apply(this, [body]);
    };
    
  }
  
  function interceptFetch() {
    const originalFetch = window.fetch;
    
    window.fetch = async function(...args) {
      const [url, options] = args;
            
      if (url && url.includes('/cart/add') && options && options.body) {
        
        try {
          let data = null;
          
          if (typeof options.body === 'string') {
            try {
              data = JSON.parse(options.body);
            } catch (e) {
            }
          } else if (options.body instanceof FormData) {
            data = {};
            data.properties = {};
            for (let [key, value] of options.body.entries()) {
              if (key.startsWith('properties[')) {
                const propName = key.match(/properties\[(.*?)\]/)[1];
                data.properties[propName] = value;
              } else if (key === 'id') {
                data.id = value;
              } else if (key === 'quantity') {
                data.quantity = value;
              }
            }
          }
          
          if (data && data.properties) {
            
            const engraveName = data.properties['Custom Engraving'] || data.properties['Engrave Name'] || data.properties['Engraving Name'];
            
            if (engraveName && engraveName.trim() && !engravingProcessed) {
              engravingProcessed = true;
              
              const response = await originalFetch.apply(this, args);
              const clonedResponse = response.clone();
              
              if (response.ok) {
                try {
                  const mainProductData = await clonedResponse.json();

                  // Skip engraving if product is in the excluded list
                  if (EXCLUDED_PRODUCT_IDS.length > 0 && EXCLUDED_PRODUCT_IDS.includes(mainProductData.product_id)) {
                    setTimeout(() => { engravingProcessed = false; }, 2000);
                    return response;
                  }
                  
                  const engraveResponse = await originalFetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: ENGRAVING_VARIANT_ID,
                      quantity: data.quantity || 1,
                      properties: {
                        '_for_product': mainProductData.product_title || 'Product',
                        '_engraved_name': engraveName.trim(),
                        '_main_product_engraving': 'true'
                      }
                    })
                  });
                  
                  if (engraveResponse.ok) {
                    const engraveData = await engraveResponse.json();
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                  } else {
                    const errorData = await engraveResponse.json();
                    console.error('Failed to add engraving via fetch:', errorData);
                  }
                } catch (error) {
                  console.error('Error in fetch handler:', error);
                } finally {
                  setTimeout(() => { engravingProcessed = false; }, 2000);
                }
              }
              
              return response;
            } else {
            }
          } else {
          }
        } catch (e) {
        }
      }
      
      return originalFetch.apply(this, args);
    };
    
  }
  
  init();
})();

(function() {
  'use strict';

  const ENGRAVING_VARIANT_ID = 48583177273567;
  let isProcessing = false;

  async function syncCart() {
    if (isProcessing) {
      return;
    }

    try {
      isProcessing = true;
      
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const itemsToRemove = [];
      const engravingItems = [];
      const mainProducts = [];

      cart.items.forEach(item => {
        if (item.variant_id === ENGRAVING_VARIANT_ID) {
          if (item.properties && item.properties['_main_product_engraving'] === 'true') {
            engravingItems.push(item);
          }
        } else if (item.properties && (item.properties['Custom Engraving'] || item.properties['Engrave Name'] || item.properties['Engraving Name'])) {
          if (!item.properties['_byob']) {
            mainProducts.push(item);
          }
        }
      });


      engravingItems.forEach(engraveItem => {
        const linkedProductTitle = engraveItem.properties['_for_product'];
        const hasMainProduct = mainProducts.some(p => p.product_title === linkedProductTitle);
        
        if (!hasMainProduct) {
          itemsToRemove.push(engraveItem.key);
        }
      });

      mainProducts.forEach(mainItem => {
        const engravingText = mainItem.properties['Custom Engraving'] || mainItem.properties['Engrave Name'] || mainItem.properties['Engraving Name'];
        
        if (engravingText && engravingText.trim()) {
          const hasEngraving = engravingItems.some(e => 
            e.properties['_for_product'] === mainItem.product_title
          );
          
          if (!hasEngraving) {
            itemsToRemove.push(mainItem.key);
          }
        }
      });

      if (itemsToRemove.length > 0) {
        
        for (const itemKey of itemsToRemove) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: itemKey,
              quantity: 0
            })
          });
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        if (window.location.pathname.includes('/cart')) {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      }

    } catch (error) {
      console.error('Sync: Error:', error);
    } finally {
      isProcessing = false;
    }
  }

  function setupCartMonitoring() {
    
    let previousCartItems = [];
    
    setInterval(async () => {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const currentCartItems = cart.items.map(i => i.key);
        
        if (previousCartItems.length === 0) {
          previousCartItems = currentCartItems;
          return;
        }
        
        const itemsRemoved = previousCartItems.filter(key => !currentCartItems.includes(key));
        
        if (itemsRemoved.length > 0) {
          await syncCart();
        }
        
        previousCartItems = currentCartItems;
        
      } catch (error) {
        console.error('Sync: Monitor error:', error);
      }
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartMonitoring);
  } else {
    setupCartMonitoring();
  }

})();
